import React from 'react';
import {CircularProgress, Divider, List, ListItem, ListItemText, ListSubheader, withStyles} from "material-ui";
import {connect} from "react-redux";
import {closeGetCompaniesFetch, getCompanies} from "../../redux/actions/companies";
import {setActiveCompanyId} from "../../redux/actions/app";

export class Companies extends React.Component {

    componentDidMount = () => {

        if (this.props.activeCompanyId <= 0) {
            this.props.onSelectCompany(0);
        }

        this.props.getCompanies((companies) => {
            if ((this.props.activeCompanyId === 0) && this.props.companies.length > 0) {
                this.onCompanySelect(this.props.companies[0]);
            } else if (this.props.companies.length > 0) {
                let company = companies.find((n) => {
                    return n.id === this.props.activeCompanyId
                });
                if (company !== undefined) {
                    this.onCompanySelect(company);
                }
            }
        });
    };

    onClickNewItem = () => {
        if (this.props.onClickNewItem !== undefined) {
            this.props.onSelectCompany(-1);
            this.props.onClickNewItem();
        }
    };

    onCompanySelect = (company) => {
        this.props.onSelectCompany(company.id);

        //コールバック関数
        if (this.props.onCompanySelect !== undefined) {
            this.props.onCompanySelect(company);
        }
    };

    render() {

        const {classes, isNewItem, companies, isGetCompaniesFetch, activeCompanyId} = this.props;

        return (
            <div className={classes.leftContainer}>

                {isNewItem ?
                    <List>
                        <ListItem button
                                  className={activeCompanyId === -1 ? classes.menuCurrent : null}
                                  onClick={this.onClickNewItem.bind(this)}>
                            <ListItemText primary="+ 新規登録"/>
                        </ListItem>
                    </List>
                    : null}
                <Divider/>

                {isGetCompaniesFetch ? <CircularProgress/> :

                    <List subheader={<ListSubheader className={classes.subHeader}>顧客一覧</ListSubheader>}>
                        {companies !== undefined ? companies.map((n) => {
                            return <ListItem button
                                             className={activeCompanyId === n.id ? classes.menuCurrent : null}
                                             key={n.id}
                                             dense
                                             onClick={this.onCompanySelect.bind(this, n)}>
                                <ListItemText primary={n.name}/>
                            </ListItem>
                        }) : null}
                    </List>
                }
            </div>
        )
    }
}

const styles = theme => ({
    leftContainer: {
        background: '#fff',
        position: 'relative',
        overflow: 'auto',
        width: 300,
    },
    menuCurrent: {
        background: '#ececec',
    },
    subHeader: {
        background: '#fff',
    },
});

Companies = withStyles(styles)(Companies);

Companies = connect(
    (state) => {
        return {
            companies: state.companies.companies,
            isGetCompaniesFetch: state.companies.isGetCompaniesFetch,
            activeCompanyId: state.app.activeCompanyId,
        }
    },
    (dispatch) => {
        return {
            onSelectCompany: (companyId) => {
                dispatch(setActiveCompanyId(companyId));
            },
            getCompanies: (callback) => {
                dispatch(getCompanies())
                    .then((response) => {
                        setTimeout(() => {
                            dispatch(closeGetCompaniesFetch());

                            switch (response.type) {
                                case 'API_GET_COMPANIES_SUCCESS':
                                    callback(response.payload.data);
                                    break;
                                default:
                            }
                        }, 500);
                    });
            }
        }
    }
)(Companies);


// WEBPACK FOOTER //
// ./src/components/companies/index.js